import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
@Component({
  selector: 'app-initiatives-page',
  templateUrl: './initiatives-page.component.html',
  styleUrls: ['./initiatives-page.component.css'],
})
export class InitiativesPageComponent implements OnInit {
  cards = [
    {
      title: 'Card 1',
      description: 'This is the content for Card 1.',
      image: 'https://placekitten.com/300/200',
    },
    {
      title: 'Card 2',
      description: 'This is the content for Card 2.',
      image: 'https://placekitten.com/300/201',
    },
    {
      title: 'Card 3',
      description: 'This is the content for Card 3.',
      image: 'https://placekitten.com/300/202',
    },
    {
      title: 'Card 4',
      description: 'This is the content for Card 4.',
      image: 'https://placekitten.com/300/203',
    },
  ];

  translateValue = '0px';

  currentIndex = 0;
  items = [
    {
      title: 'Item 1',
      content: 'Content 1',
      src: 'assets/images/startup-logo.png',
    },
    { title: 'Item 2', content: 'Content 2' },
    { title: 'Item 3', content: 'Content 3' },
    // Add more items as needed
  ];

  showLeftArrow: boolean = true;
  constructor() {}

  ngOnInit(): void {}
  /**
   * Toggles the visibility of right arrows and scrolls the widgets content to the right.
   *
   * This method scrolls the widgets content to the right by 1200 pixels with smooth behavior.
   * It also sets the showLeftArrow property to false.
   */
  toggleRightArrows() {
    // Scroll the widgets content to the right by 1200 pixels with smooth behavior
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft + 1200,
      behavior: 'smooth',
      transform: 'scale(1.1)', // Scale up the content while scrolling for a nice effect
    });
    // Set showLeftArrow to false to hide left arrows
    this.showLeftArrow = false;
  }
  /**
   * Toggles the visibility of left arrows and scrolls the widgets content to the left.
   *
   * This method scrolls the widgets content to the left by 1200 pixels with smooth behavior.
   * It also sets the showLeftArrow property to true.
   */
  toggleLeftArrows() {
    // Scroll the widgets content to the left by 1200 pixels with smooth behavior
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft - 1200,
      behavior: 'smooth',
    });

    // Set showLeftArrow to true to ensure left arrows are visible
    this.showLeftArrow = true;
  }
  /**
   * Advances to the previous card in the list.
   *
   * This method decrements the currentIndex to show the previous card.
   * It wraps around to the end of the list when the beginning is reached.
   * After updating the index, it calls updateTransform to adjust the view.
   */
  prevCard() {
    // Decrement currentIndex and wrap around using modulo
    this.currentIndex =
      (this.currentIndex - 1 + this.cards.length) % this.cards.length;
    // Update the transform to reflect the new current card
    this.updateTransform();
  }

  /**
   * Advances to the next card in the list.
   *
   * This method increments the currentIndex to show the next card.
   * It wraps around to the beginning of the list when the end is reached.
   * After updating the index, it calls updateTransform to adjust the view.
   */
  nextCard() {
    // Increment currentIndex and wrap around using modulo
    this.currentIndex = (this.currentIndex + 1) % this.cards.length;
    // Update the transform to reflect the new current card
    this.updateTransform();
  }

  /**
   * Updates the CSS transform property of the cards container element to
   * smoothly slide the cards to the left or right.
   *
   * This method is called whenever the user navigates to a different card.
   */
  updateTransform() {
    const offset = -this.currentIndex * 300; // Assuming each card is 300px wide
    this.translateValue = offset + 'px'; // Update the translate value
  }
  @ViewChild('widgetsContent', { read: ElementRef })
  public widgetsContent: ElementRef<any>;
  /**
   * Smoothly scrolls the widgets content to the right by 150 pixels.
   *
   * This method will also scale the content up by 10% while it is scrolling,
   * which gives the user a visual cue that the content is being scrolled.
   */
  public scrollRight(): void {
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft + 150,
      behavior: 'smooth',
      transform: 'scale(1.1)',
    });
  }

  /**
   * Smoothly scrolls the widgets content to the left by 150 pixels.
   */
  public scrollLeft(): void {
    // Scroll the widgets content to the left by 150 pixels with smooth behavior
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft - 150,
      behavior: 'smooth',
    });
  }
}
